
import { Options, Vue } from "vue-class-component";
import SortByMenu from "./SortByMenu.vue";
import SearchBar from "./SearchBar.vue";
import TagSelect from "./TagSelect.vue";

@Options({
  components: {
    SortByMenu,
    SearchBar,
    TagSelect,
  },
  props: {
    navText: Array,
    category: Array,
    selectItems: Array,
    route: String,
  },
})
export default class MainHeaderSortMenu extends Vue {
  category!: string[];
  selectItems!: string[];
  route!: string;
}
